export class Store {
    id: string;
    name: string;
    status: string;
    dept_id: string;
    branch_id: string;
    row_id: string;
    creation_user: string;
    creation_ip: string;
    created_at: string;
    showDeletedOnly: boolean;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/stores/store.ts